import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import {paymentMethodBasicInformationPropTypes} from '../proptypes/PaymentMethodPropTypes';

const PaymentMethodBasicInformationResource = ({
    name, description, transactionCode
}) => (
  <>
    <ResourceProperty label="Name:">{name}</ResourceProperty>
    <ResourceProperty label="Descripción:">
      {description}
    </ResourceProperty>
    <ResourceProperty label="Código de Transacción:">
      {transactionCode}
    </ResourceProperty>
  </>
);

PaymentMethodBasicInformationResource.propTypes =
  paymentMethodBasicInformationPropTypes;

export default PaymentMethodBasicInformationResource;
